<!-- SCRIPTS -->
//ONLOAD
jQuery(document).ready(function( $ ){

// COOKIE BAR
cookiebar_activate = (typeof cookiebar_activate !== 'undefined')? cookiebar_activate : null;
if(cookiebar_activate) {
	$.cookieBar(cookiebar_activate);
	//ANALYTICS DATA
	if(jQuery.cookieBar('cookies')){load_google_analitics();}
}

//MOMENTS SETUP
moment_activate = (typeof moment_activate !== 'undefined')? moment_activate : null;
if(moment_activate) {
	moment.locale('hr');
	moment.locale('hr', moment_activate);
}

//LANDING LOG
var hash = null;
var hash_switch = true;
if(hash = window.location.hash) {
	console.log('hash: '+hash)
}

//MODAL LANDING
if(hash) {
	$(hash+'.modal').modal('toggle');
	hash_switch = false;
}



// TABS
$('.make-tabs a').click(function (e) {
  e.preventDefault();
  $(this).tab('show');
});

//TAB LANDING
if(hash) {
	$(hash+'.tab-pane').tab('show');
	hash_switch = false;
}


// TARGET LANDING
// Add smooth scrolling to all links inside a navbar
if(hash && hash_switch) {
    $('html, body').animate({
        scrollTop: $(hash).offset().top
    }, 800);
}


// NAVBAR & STICKY
// Go to nav menu on second click
$(".navbar li.dropdown > a").on('click', function(event) {
    if ($(this).parent().hasClass('open')) {
        event.preventDefault();
        window.location.href = this.href;
    }
});

// Fix document heights and top padding
$('.navbar-toggle').click(function() {

$(window).resize(checkNavHeight);
function checkNavHeight() {
        var offsetH = $('.forSticky');
        var navH = $('.navbar-top').outerHeight();
        offsetH.animate({'padding-top' : navH }, 50);
}
function checkNavHeightL() {
        var offsetH = $('.forSticky');
        var navH = $('.navbar-top').outerHeight();
        offsetH.animate({'padding-top' : navH }, 500);
}

setTimeout(function(){checkNavHeight();}, 50);

setTimeout(function() {
var offsetH = $('.forSticky');
var navH = $('.navbar-top').outerHeight();
setTimeout(checkNavHeightL(), 2);}, 802);
});

//Fix search
$('#search_dropdown > a').click(function() {
  setTimeout(function(){$('#nav_search_field').focus();}, 100);
});

// Add smooth scrolling to all links inside a navbar
$(".nav a[href^='#']").on('click', function(event){
    event.preventDefault();
    var hash = this.hash;
    $('html, body').animate({
        scrollTop: $(hash).offset().top
    }, 800, function(){
        window.location.hash = hash;
    });
});


// Content fix

//fix image

$('.content img').each(function(){
	$cancel_img_strip = false;
	if($(this).hasClass("img-circle")) $cancel_img_strip = true;
	if($(this).hasClass("img-thumbnail")) $cancel_img_strip = true;
	if($(this).hasClass("img-rounded")) $cancel_img_strip = true;
	if(!$cancel_img_strip) {
		$(this).removeAttr('width');
		$(this).removeAttr('height');
	}
});




// Footer fix
 var fixFooter = function($target) {

	 	 $($target).removeClass('footer-fix');
		 var content_height = $($target).offset();
		 var footer_height = $($target).height();
		 var window_height = $(window).height();
		 var page_height = content_height.top + footer_height;
		 if (page_height < window_height ) {
			 $($target).addClass('footer-fix');
		 }
  };

setTimeout(function(){ fixFooter('#footer')},500);


// Navclear fix
var navClear = function() {
	$(".navclear").each(function() {
	    target = this.id;
			target = target.replace("navclear", "navbar");
			$target = '#' + target;
			$target_height = $($target).height();
			$(this).css({"height": $target_height});
	});
};
navClear();










// Refresh styles
var refreshPage = function() {

	fixFooter('#footer');
	//navClear();

 };

 $( window ).resize(function() {
  refreshPage();
 });



// END

});
